import React from "react";

import { BulletList, BulletListType } from "@at/design-system-patterns";

import { getChannelSingular } from "@at/formatter-utils";

import { setLeasingModal } from "../../../../../../contexts/leasing/actions/leasing.actions";
import { useLeasingDispatchContext } from "../../../../../../contexts/leasing/context/leasing.context";
import { LeasingModals } from "../../../../../../contexts/leasing/types/leasing.types";
import { useChannel } from "../../../../../../utils/hooks/use-channel";
import * as Styled from "../how-leasing-works-tabs.styled";

export const StepByStep = () => {
  const dispatch = useLeasingDispatchContext();
  const channel = useChannel();
  const singularChannel = getChannelSingular(channel);

  const handleOpenAboutModal = () => {
    dispatch(
      setLeasingModal({
        show: true,
        type: LeasingModals.HOW_LEASING_WORKS,
        title: `How Leasing Works with Auto Trader`,
        footerButtonText: "Back",
      }),
    );
  };
  return (
    <Styled.LeasingPanelContainer>
      <p>
        Leasing works a bit like a long-term rental. You drive it, but you don’t
        own it.
      </p>
      <BulletList
        listType={BulletListType.ORDERED}
        items={[
          `Choose your ${singularChannel}, pick your terms and apply for lease credit online`,
          `Pay monthly rental payments for your chosen term length`,
          `Drive it, enjoy it, then give it back at the end`,
        ]}
      />
      <Styled.LeasingTabsButton
        onInteraction={() => handleOpenAboutModal()}
        text="Learn more about how it works"
        displayType="tertiary"
        underline
      />
    </Styled.LeasingPanelContainer>
  );
};
